"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeights = void 0;
exports.fontWeights = {
    extraBold: 600,
    bold: 500,
    regular: 400,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vdXRpbHMvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsV0FBVyxHQUFHO0lBQ3pCLFNBQVMsRUFBRSxHQUFHO0lBQ2QsSUFBSSxFQUFFLEdBQUc7SUFDVCxPQUFPLEVBQUUsR0FBRztDQUNKLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgZm9udFdlaWdodHMgPSB7XG4gIGV4dHJhQm9sZDogNjAwLFxuICBib2xkOiA1MDAsXG4gIHJlZ3VsYXI6IDQwMCxcbn0gYXMgY29uc3Q7XG4iXX0=